import { tracking } from './tracking'

export const analytics = {
  upgraded(plan, invoice) {
    tracking.gtm.event({
      name: 'upgraded_subscription',
      label: `${plan.product_name} ${plan.schedule}`,
      extra: {
        value: invoice.total_raw,
        currency: 'USD',
        content_name: `${plan.product_name} ${plan.schedule}`
      }
    })
  }
}
